import { Link } from 'foundations-components/transitional/components/Link';
import { useEmbeddedEditorContext } from './EmbeddedEditorContext';
import { useCallback } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ANCHOR_NAVIGATION_QUERY_PARAM } from './constants';
import { StudioAnchorWrapper } from './AnchorNavigation';
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultText = () => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "embeddedEditor.openFullEditor"
  });
};
export const useOpenFullEditor = ({
  anchor
} = {}) => {
  const {
    handleCloseEditor
  } = useEmbeddedEditorContext();
  const handleOpenFullEditor = useCallback(() => {
    window.open(`${window.location.pathname}?${ANCHOR_NAVIGATION_QUERY_PARAM}=${anchor}`, '_blank');
    handleCloseEditor === null || handleCloseEditor === void 0 || handleCloseEditor();
  }, [handleCloseEditor, anchor]);
  return {
    handleOpenFullEditor
  };
};
export const OpenFullEditorLink = ({
  children,
  anchor
}) => {
  const {
    handleOpenFullEditor
  } = useOpenFullEditor({
    anchor
  });
  const text = children || /*#__PURE__*/_jsx(DefaultText, {});
  return /*#__PURE__*/_jsx(StudioAnchorWrapper, {
    anchor: anchor,
    children: /*#__PURE__*/_jsx(Link, {
      external: true,
      onClick: handleOpenFullEditor,
      children: text
    })
  });
};
export const OpenFullEditorButton = ({
  children,
  anchor
}) => {
  const {
    handleOpenFullEditor
  } = useOpenFullEditor({
    anchor
  });
  const text = children || /*#__PURE__*/_jsx(DefaultText, {});
  return /*#__PURE__*/_jsx(StudioAnchorWrapper, {
    anchor: anchor,
    children: /*#__PURE__*/_jsx(Button, {
      onClick: handleOpenFullEditor,
      children: text
    })
  });
};